'use strict';

exports.__esModule = true;
exports.merge = merge;

var _Identifiers = require('../types/Identifiers');

var _identify = require('./utils/identify');

var getIdentifier = function getIdentifier(tag) {
  var identifier = (0, _identify.identify)(tag);
  if (identifier === _Identifiers.IDENTIFIERS.STRUCTURED_DATA) {
    try {
      var jsonData = JSON.parse(tag.children);
      var scriptType = jsonData && jsonData['@type'];
      return identifier + ' - ' + scriptType;
    } catch (error) {}
  }
  return identifier;
};

function merge(a, b) {
  var tags = [];
  var uniqueTagCache = {};

  var safeA = Array.isArray(a) ? a : [];
  var safeB = Array.isArray(b) ? b : [];

  var merged = [].concat(safeB.some(function (tag) {
    return tag.custom;
  }) ? safeA.filter(function (tag) {
    return !tag.custom;
  }) : safeA).concat(safeB);

  for (var i = merged.length - 1; i >= 0; i--) {
    var identifier = getIdentifier(merged[i]);
    if (identifier) {
      if (!uniqueTagCache[identifier]) {
        tags.unshift(merged[i]);
        uniqueTagCache[identifier] = true;
      }
    } else {
      tags.unshift(merged[i]);
    }
  }

  return tags;
}